import { useEffect, useState } from "react";

const useOutsideClick = (ref, onClickOutside = () => { }, exceptions = []) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    let timeout
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target) && !exceptions.filter(c => [...(event.target?.classList || [])].includes(c)).length) {
        timeout = setTimeout(() => {
          onClickOutside()
        }, 100)
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      clearTimeout(timeout)
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}


export {
  useOutsideClick,
  useDebounce,
  useWindowDimensions
}